import { useLanguageSync } from '@/shared/hooks/use-language-sync';

export const LanguageSync = () => {
  useLanguageSync();
  return null;
};
